import React from "react";

import img1 from "../img/The 4th Seal or the crown of silence&&Chants of the Forgotten Interface---Adobe Photoshop interweaving of textured layers over AI-generated and curated images___2025-06[[4]].jpg"

export default function Machine_2_1_1() {
  return (
    <div className="panel-block">
      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="2.1.1 · A LIVING NATURE"
        />
      </div>

      <div className="panel-container-right">
        <h2>2.1.1 · How it works</h2>

            <p>
          Some artifacts have limited downloads.
        </p>

        <p>
          Some may reappear altered over time.          
        </p>

        <p>
          Not everything returns.
        </p>

        <p>
         Your support keeps the system alive.
        </p>
        <p>
          <a target="_blank" rel="noreferrer" href="https://ko-fi.com/vakzthar">Visit The Vault Here</a></p>
     
      </div>
    </div>
  );
}
